// Mirrors the bulk-communications attachment limits (`EmailCompose.jsx`). The lottery create
// endpoint enforces the same numbers server-side, so these are UX only, not the boundary.
export const MAX_ATTACHMENT_SIZE = 10e6;
export const MAX_ATTACHMENT_SIZE_MB = MAX_ATTACHMENT_SIZE / 10e5;

// A deliberate divergence from bulk communications, which has no allowlist: PDFs, Word
// documents and common images only. The server enforces the same set in
// `LotteryBatchCreateSerializer.validate_attachments`.
export const ALLOWED_ATTACHMENT_EXTENSIONS = [
  'pdf',
  'docx',
  'jpg',
  'jpeg',
  'png',
  'gif',
  'webp',
  'heic',
  'heif',
  'tif',
  'tiff',
  'bmp',
] as const;

export const ALLOWED_ATTACHMENT_MIME_TYPES: ReadonlySet<string> = new Set([
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/heic',
  'image/heif',
  'image/tiff',
  'image/bmp',
]);

export const ATTACHMENT_ACCEPT = ALLOWED_ATTACHMENT_EXTENSIONS.map(
  (extension) => `.${extension}`
).join(',');

/**
 * The allowlist check the picker applies before adding a file. An allowlisted extension with
 * a non-empty content type outside the list is rejected, mirroring the server; a browser that
 * reports no content type is trusted on the extension alone.
 */
export function isAllowedAttachmentType(
  fileName: string,
  mimeType = ''
): boolean {
  const extension = fileName.split('.').pop()?.toLowerCase() ?? '';
  if (
    !(ALLOWED_ATTACHMENT_EXTENSIONS as readonly string[]).includes(extension)
  ) {
    return false;
  }
  const normalizedType = mimeType.toLowerCase();
  return !normalizedType || ALLOWED_ATTACHMENT_MIME_TYPES.has(normalizedType);
}
